const normalizeRedirectPath = (path: string) => {
  const trimmedPath = path.trim();

  if (!trimmedPath) {
    return null;
  }

  const prefixedPath = trimmedPath.startsWith('/')
    ? trimmedPath
    : `/${trimmedPath}`;

  return prefixedPath.length > 1
    ? prefixedPath.replace(/\/+$/, '')
    : prefixedPath;
};

export const parseCustomHomeRedirectPaths = (value?: string) =>
  Array.from(
    new Set(
      (value || '')
        .split(',')
        .map(normalizeRedirectPath)
        .filter((path): path is string => Boolean(path) && path !== '/'),
    ),
  );

export const getCustomHomeRedirectPaths = () =>
  parseCustomHomeRedirectPaths(import.meta.env.VITE_CUSTOM_HOME_REDIRECT_PATHS);
